import { connect } from 'react-redux'

// Components
import { Toast } from '@tracklib/kit'

// Selectors
import { selectRevenueReportingStatus } from 'modules/usersongs/selectors'
import { selectRequest } from 'modules/requests/selectors'

// Types
import { ApiRequest, State } from 'types'

// Utils
import formatDate from 'lib/formatdate'

type OwnProps = Record<string, unknown>

type ReportRevenueToastProps = OwnProps & {
  revenueReportingStatus: {
    reportingNeeded: boolean
    paymentNeeded: boolean
    dueDate: string
    reportingOpen: boolean
  }
  fetchAllUserSongsRequest: ApiRequest
}

const ReportRevenueToast = (props: ReportRevenueToastProps): JSX.Element => {
  const {
    revenueReportingStatus: { reportingOpen, reportingNeeded, paymentNeeded, dueDate },
    fetchAllUserSongsRequest,
  } = props
  if (!fetchAllUserSongsRequest.isDone || !reportingOpen) {
    return <div />
  }

  return (
    <>
      {reportingNeeded && !paymentNeeded && (
        <Toast
          title={"It's time to report your revenue for all your active licenses"}
          description={`Revenue report is due ${formatDate(dueDate)}`}
          buttonText="Report revenue"
          buttonUrl="/yoursongs/revenuereporting/"
          type="danger"
          fullWidth
        />
      )}
      {!reportingNeeded && paymentNeeded && (
        <Toast
          title="You have unpaid royalties"
          description={`Payment is due ${formatDate(dueDate)}`}
          buttonText="Pay royalties"
          buttonUrl="/yoursongs/revenuereporting/"
          type="danger"
          fullWidth
        />
      )}
      {!reportingNeeded && !paymentNeeded && (
        <Toast
          type="neutral"
          title="You can still make changes to your revenue report"
          description={`Reporting closes on ${formatDate(dueDate)}`}
          buttonText="Report revenue"
          buttonUrl="/yoursongs/revenuereporting/"
          fullWidth
        />
      )}
    </>
  )
}

const mapStateToProps = (state: State) => {
  return {
    revenueReportingStatus: selectRevenueReportingStatus(state),
    fetchAllUserSongsRequest: selectRequest(state, 'FETCH_ALL_USER_SONGS'),
  }
}
export default connect(mapStateToProps)(ReportRevenueToast)
